import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import EA from '../helpers/init';

export default EA.Methods.cardSliderHandler = ($this) => {
    const slider = $this.querySelector('.card-swiper');

    new Swiper(slider, {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 12,
        loop: true,
        centerInsufficientSlides: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        breakpoints: {
            601: {
                spaceBetween: 20
            }
        }
    });
};